import type { FC } from "react";
import type { Blocker } from "react-router";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../alert-dialog";

export interface UnsavedChangesDialogProps {
  blocker: Blocker;
  title?: string;
  message?: string;
  confirmLabel?: string;
}

export const UnsavedChangesDialog: FC<UnsavedChangesDialogProps> = ({ blocker, title, message, confirmLabel }) => {
  if (blocker.state !== "blocked") {
    return null;
  }

  return (
    <AlertDialog open={true} onOpenChange={() => blocker.reset && blocker.reset()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title ?? "Unsaved Changes"}</AlertDialogTitle>
          <AlertDialogDescription>
            {message ??
              "You have autosave paused. Any changes since your last save will be lost if you leave this page."}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => blocker.reset && blocker.reset()}>Stay on page</AlertDialogCancel>
          <AlertDialogAction onClick={() => blocker.proceed && blocker.proceed()} theme="destructive">
            {confirmLabel ?? "Leave without saving"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
